export async function handleDSKeyChange(t, inputName = 'key') {
  if (!this.node.elements) {
    console.warn('handleDSKeyChange must be used inside a Form')
    return
  }
  const { state: s } = this
  const type = t.toUpperCase()

  const text = this.node.elements.item(inputName).value

  if (!text) {
    return
  }

  const previousKey = s.key
  const newKey =
    type === 'SPACING' || type === 'TYPOGRAPHY'
      ? this.call('handleAtKey', text)
      : text

  if (!s.value || !previousKey) {
    return s.update({ key: newKey })
  }

  const path = (k) => ['designSystem', type, k]
  this.sdk.updateData(
    [
      ['update', path(newKey), s.value],
      ['delete', path(previousKey)]
    ],
    {
      message: `Renamed ${previousKey} to ${newKey}`
    }
  )

  // this.lookup('DynamicIsland').update()
  this.updateDesignSystemOnCanvas(this.getDesignSystem())

  s.update({ key: newKey })
  await this.call('rerenderFileSidebarByType', type.toLowerCase())
}

export async function handleGlobalThemeKeyChange() {
  if (!this.node.elements) {
    console.warn('handleDSKeyChange must be used inside a Form')
    return
  }
  const { state: s } = this
  const type = 'THEME'

  const text = this.node.elements.item('global-theme-key').value

  if (!text) {
    return
  }

  const previousKey = s.key
  const newKey = this.call('handleAtKey', text)

  if (!s.value || !previousKey) {
    return s.update({ key: newKey })
  }

  const path = (k) => ['designSystem', type, 'document', k]
  this.sdk.updateData(
    [
      ['update', path(newKey), s.value],
      ['delete', path(previousKey)]
    ],
    {
      message: `Renamed Global Theme ${previousKey} to ${newKey}`
    }
  )

  this.lookup('DynamicIsland').update()
  // TODO: Check if this is needed
  this.updateDesignSystemOnCanvas(this.getDesignSystem())

  s.update({ key: newKey })
}

export function handleMediaIcon(media) {
  const { value: mediaQuery = media } = this.state

  if (!mediaQuery) {
    return ''
  }

  if (mediaQuery === 'print') {
    return 'print outline'
  }
  if (mediaQuery.includes('prefers-color-scheme: light')) {
    return 'sun outline'
  }
  if (mediaQuery.includes('prefers-color-scheme: dark')) {
    return 'moon outline'
  }

  const widthMatch = mediaQuery.match(/(?:min|max)-width:\s*(?<width>\d+)/u)
  if (!widthMatch) {
    return 'displayPreferencesFill'
  }

  const width = parseInt(widthMatch.groups.width, 10)
  const isMin = mediaQuery.includes('min-width')

  if (width >= 1920) {
    return isMin ? 'device big screen half fill' : 'device big screen outline'
  }
  if (width >= 1366) {
    return isMin ? 'device big screen outline' : 'device small screen outline'
  }
  if (width >= 1024) {
    return isMin
      ? 'device small screen outline'
      : 'device tablet landscape outline'
  }
  if (width >= 540) {
    return isMin
      ? 'device tablet landscape outline'
      : 'device tablet portrait outline'
  }
  return isMin ? 'device tablet portrait outline' : 'device mobile outline'
}

export function handleDsNavbarClick() {
  const { key } = this.props
  const val = this.getWindow('explorer') === key ? false : key
  this.setWindow('explorer', val)
}
